const NotFound = () => (
  <div className="text-center m-4 p-4">
    <h2>Oops!</h2>We couldn&apos;t find that page. Try going <a href="/">home</a>.
  </div>
);

export default NotFound;
